import React from 'react';
import { motion } from 'framer-motion';
export function ProductIntro() {
  return <section className="py-10 md:py-20 px-5 md:px-6 bg-[#F0F8FB]" data-id="element-152">
      <div className="max-w-5xl mx-auto text-center" data-id="element-153">
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-lg md:text-3xl text-gray-700 mb-8 md:mb-14 max-w-3xl mx-auto leading-snug md:leading-relaxed font-light" data-id="element-154">
          Si quieres alimentar a tu bebé saludable de forma{' '}
          <em className="text-[#2D1F1A] font-medium" data-id="element-155">
            rápida y sin estrés ni miedo
          </em>
          , esta es{' '}
          <span className="font-bold text-[#F9A8B7] not-italic" data-id="element-156">
            la herramienta definitiva
          </span>
          .
        </motion.p>
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-white p-6 md:p-14 rounded-3xl shadow-xl border border-[#A9D7E2]/30 relative overflow-hidden" data-id="element-157">
          <div className="absolute top-0 left-0 w-full h-2 bg-[#F9A8B7]" data-id="element-158"></div>
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold text-[#2D1F1A] mb-4 md:mb-6 leading-tight md:leading-[1.1] tracking-tight" data-id="element-159">
            Guía Completa Para la{' '}
            <em className="text-[#F9A8B7] not-italic" data-id="element-160">
              Alimentación de Tu Bebé
            </em>
          </h2>
          <p className="text-base md:text-xl text-gray-600 font-medium mb-6 md:mb-10 italic" data-id="element-161">
            La{' '}
            <span className="underline decoration-[#F9A8B7] decoration-2 underline-offset-4 not-italic font-bold text-[#2D1F1A]" data-id="element-162">
              Base de Datos Más Completa
            </span>{' '}
            del Mundo Hispano de Recetas y Menús Para Bebés.
          </p>
          <div className="relative max-w-md mx-auto aspect-[4/3] rounded-2xl overflow-hidden shadow-lg border border-gray-100" data-id="element-163">
            <img src="https://cdn.magicpatterns.com/uploads/etnZ3zcyR6MxC3LWddbSua/DEF.png" alt="Recetas para bebés - Guía completa con 500+ recetas" className="w-full h-full object-cover" data-id="element-164" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent flex items-end p-6" data-id="element-165">
              <p className="text-white font-bold text-xl" data-id="element-166">
                500+ Recetas Exclusivas
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}